<template>
  <div>
    <div class="ibox">
      <div class="ibox-title">
        <h3>Posts</h3>
      </div>
      <div class="ibox-content">
        <div class="table-responsive">
          <table class="table table-hover issue-tracker" v-if="postsLoaded">
            <thead>
              <tr>
                <th>Type</th>
                <th>Title</th>
                <th>Lang</th>
                <th>Site</th>
                <th v-if="postList[0].site.stats">RD</th>
                <th v-if="postList[0].site.stats">TF</th>
                <th v-if="postList[0].site.stats">DA</th>
                <th>Modified</th>
                <th>Added</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
            <tr v-for="p in postList" :key="p.postId">
              <td>
                <span class="label" v-bind:class="getClassType(p.type)">{{ p.type }}</span>
              </td>
              <td class="issue-info">
                <router-link tag="a" :to="'/site/' + p.site.id + '/post/' + p.postId">
                  {{ p.title }}
                </router-link>
              </td>
              <td>
                {{ p.lang }}
              </td>
              <td>
                {{ p.site.url }}
              </td>
              <td v-if="p.site.stats">
                {{ p.site.stats.rd }}
              </td>
              <td v-if="p.site.stats">
                {{ p.site.stats.tf }}
              </td>
              <td v-if="p.site.stats">
                {{ p.site.stats.da }}
              </td>
              <td :title="$moment(p.modified.date).format('DD.MM.YYYY HH:mm')">
                {{ $moment(p.modified.date).calendar() }}
              </td>
              <td>
                {{ $moment(p.postDate.date).format('DD.MM.YYYY HH:mm') }}
              </td>
              <td>
                {{ p.status }}
              </td>
              <td class="text-right">
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
import { eventBus } from '../../../main'

export default {
  name: 'PostList',
  data () {
    return {
      siteLoaded: false,
      postsLoaded: false,
      postList: []
    }
  },
  created () {
    eventBus.$on('postList', (result) => {
      if (!result) {
        this.postList = []
        this.postsLoaded = false
      } else {
        this.postList = result
        this.postsLoaded = true
      }
    })
  },
  mounted () {
    // this.getPosts(this.$route.params.id)
  },
  methods: {
    getClassType (type) {
      return type === 'post' ? 'label-primary' : 'label-secondary'
    },
    reloadPosts () {
      this.getPosts(this.$route.params.id)
    }
  }
}
</script>
<style scoped>
.pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Site/PostList.vue